import AccessResponse from "admin/types/interfaces/access";
import { useFetcher } from "~/hooks/useFetcher";
import { ACCESS_CONTROLLER_V1 } from "~/utils/accessController";

const useUserAccess = (email: string) => {
  return useFetcher<AccessResponse>(`${ACCESS_CONTROLLER_V1}/users/${email}/access`);
};

export default useUserAccess;
